module.exports = __webpack_public_path__ + "3e3b0cc27b46e14fa5512234e812d58f.svg";